import React from 'react';
import type { FC } from 'react';
import cn from 'classnames';
import { separateThousands } from '@alfa-bank/site-helpers-transform/numbers/separate-thousands';
import { getTrendStatus } from '@alfa-bank/site-invest-common/helpers/utils/get-trend-status';
import { isNumber } from '@alfa-bank/site-invest-common/helpers/numbers/is-number';
import { getMathAbs } from '@alfa-bank/site-invest-common/helpers/numbers/get-math-abs';
import { TREND_STATUS, TREND_SYMBOLS } from '@alfa-bank/site-invest-common/constants/other';

import styles from './styles.css';
export const DATA_TEST_ID = 'profitability-renderer';
interface IProfitabilityRendererProps {
    className?: string;
    fallbackValue?: string;
    profitabilitySymbol?: string;
    showTrendSymbol?: boolean;
    value?: number | null;
}

/** Обрабатывает относительные значения, типа profitabilityPercent */
export const ProfitabilityRenderer: FC<IProfitabilityRendererProps> = ({
    className,
    fallbackValue = '',
    profitabilitySymbol = '%',
    showTrendSymbol = false,
    value,
}) => {
    const trend = getTrendStatus(value);

    const trendSymbol = showTrendSymbol ? TREND_SYMBOLS[trend] : '';

    const result = isNumber(value)
        ? `${trendSymbol}${separateThousands(getMathAbs(value))}${profitabilitySymbol}`
        : fallbackValue;

    return (
        <span
            className={cn(
                styles.text,
                {
                    [styles.positive]: trend === TREND_STATUS.positive,
                    [styles.negative]: trend === TREND_STATUS.negative,
                    [styles.neutral]: trend === TREND_STATUS.neutral,
                },
                className
            )}
            data-test-id={DATA_TEST_ID}
        >
            {result}
        </span>
    );
};
